/**
 * FLIGHT SCHOOL CONTENT CONFIG
 * ============================
 * Central control panel for all video content used in flight school modules.
 * These are fallback lesson IDs used when the backend config is unavailable.
 * To update lesson IDs, use the admin UI at /flight-school-config.
 *
 * These IDs point to real beginner-level lessons used as temporary placeholders.
 * Swap them to cognate-specific videos via the admin config when available.
 */

// ── MODULE 1: CION & ANTE ──────────────────────────────────────────
export const M1_INTRO_VIDEO_LESSON_ID = 267;       // Meeting Patrick — placeholder for cognates intro
export const M1_CION_RULE_LESSON_ID = 275;          // Meet Diego — placeholder for CION rule video
export const M1_ANTE_CONTEXT_LESSON_ID = 287;       // Basic Spanish Phrases — placeholder for ANTE context

// ── MODULE 2: DAD & MENTE ──────────────────────────────────────────
export const M2_DAD_RULE_LESSON_ID = 294;           // 3 Word Phrases — placeholder for DAD rule video
export const M2_MENTE_RULE_LESSON_ID = 296;         // Must Know Phrases — placeholder for MENTE rule video
export const M2_REVIEW_LESSON_ID = 298;             // Spanish Commands Part 2 — placeholder for review

// ── MODULE 3: REVIEW ALL PATTERNS ──────────────────────────────────
export const M3_REVIEW_1_LESSON_ID = 300;           // Phrases with Por — placeholder for ANTE review
export const M3_REVIEW_2_LESSON_ID = 302;           // REAL Spanish Phrases — placeholder for MENTE review
export const M3_REVIEW_3_LESSON_ID = 304;           // Gender in Spanish — placeholder for general review

// ── FILL IN THE BLANK ──────────────────────────────────────────────
// Each fill-in-the-blank activity gets a dedicated video whose words match its sentence.
export const M1_FILL_COMUNICACION_LESSON_ID = 286;  // Basic Spanish Commands — placeholder for comunicación
export const M1_FILL_NACION_LESSON_ID = 292;        // Phrases you NEED to know — placeholder for nación
